module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Curtains-67fea2430022291f24cab2727fb486b715b8e64f2e55c009320ec776c058156d.svg";